import {
  RadioButtonCheckedTwoTone,
  RadioButtonUncheckedTwoTone,
} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  Slide,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

type OnlineToursSortingDialogProps = {
  open: boolean;
  onClose: () => void;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function OnlineToursSortingDialog({
  open,
  onClose,
}: OnlineToursSortingDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      sx={{
        '.MuiDialog-container': {
          height: '800px',
        },
        '.MuiDialog-paper': {
          m: 1,
          width: '100%',
          pb: 2,
        },
      }}
    >
      <DialogTitle>
        {t('onlineToursSortingDialog.title')}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <List>
        <SortingItem value="availableCapacity,asc" onClose={onClose}>
          {t('onlineToursPage.lastQuotas')}
        </SortingItem>
        <SortingItem value="adultPriceUSD,asc" onClose={onClose}>
          {t('onlineToursPage.increasingByPrice')}
        </SortingItem>
        <SortingItem value="adultPriceUSD,desc" onClose={onClose}>
          {t('onlineToursPage.decreasingByPrice')}
        </SortingItem>
        <SortingItem value="startDate,asc" onClose={onClose}>
          {t('onlineToursPage.nearestDate')}
        </SortingItem>
      </List>
    </Dialog>
  );
}

function SortingItem(props: {
  value: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  const [queryParams, setQueryParams] = useSearchParams();
  const currentValue = queryParams.get('sort');

  const setSort = (value: string) => {
    const newParams = new URLSearchParams(queryParams.toString());
    newParams.set('sort', value);
    setQueryParams(newParams);
    props.onClose();
  };

  return (
    <ListItemButton onClick={() => setSort(props.value)}>
      <ListItemIcon>
        {currentValue === props.value ? (
          <RadioButtonCheckedTwoTone color="primary" />
        ) : (
          <RadioButtonUncheckedTwoTone />
        )}
      </ListItemIcon>
      {props.children}
    </ListItemButton>
  );
}
